export enum WindsimModule {
  None = 0,
  Map = 1,
  Model = 2,
  Simulations = 3,
  Mmc = 4,
  Files = 5,
}
